module.exports = "/_next/static/images/bi-cf790c09c38acf63e40c9b83665b78bb.svg";